import z from 'zod';

export const SHORTLIST_STORAGE_KEY = 'vehicle-shortlist' as const;
export const MAXIMUM_SHORTLIST_LENGTH = Number(process.env.NEXT_PUBLIC_MAXIMUM_SHORTLIST_LENGTH ?? 200);

const Shortlist = z.array(z.string()).max(MAXIMUM_SHORTLIST_LENGTH);

const saveShortlist = (shortlist: Iterable<string>) => {
  const storageItem = JSON.stringify([...shortlist]);
  globalThis.localStorage.setItem(SHORTLIST_STORAGE_KEY, storageItem);
  globalThis.dispatchEvent(new Event('storage'));
};

export const getShortlist = () => {
  const storageItem = globalThis.localStorage.getItem(SHORTLIST_STORAGE_KEY);

  if (storageItem === null) {
    return [];
  }

  const { success, data } = Shortlist.safeParse(JSON.parse(storageItem));

  if (!success) {
    return [];
  }

  return data;
};

export const addToShortlist = (vehicleId: string) => {
  const shortlist = new Set(getShortlist());

  if (shortlist.size === MAXIMUM_SHORTLIST_LENGTH) {
    return;
  }

  shortlist.add(vehicleId);
  saveShortlist(shortlist);
};

export const removeFromShortlist = (vehicleId: string) => {
  const shortlist = new Set(getShortlist());
  shortlist.delete(vehicleId);
  saveShortlist(shortlist);
};

export const clearShortlist = () => {
  saveShortlist([]);
};

export const isShortlistFull = () => {
  return getShortlist().length >= MAXIMUM_SHORTLIST_LENGTH;
};
